<template>
  <v-dialog
      v-model="projManager"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true"
      content-class="rounded-lg"
  >
    <v-card class="elevation-6" style="border-radius: 12px; max-height: 90vh; display: flex; flex-direction: column;">
      <!-- 蓝色渐变顶部栏 -->
      <v-toolbar flat dark color="primary" class="rounded-t-lg">
        <v-toolbar-title class="font-weight-medium text-subtitle-1">
          主管{{userName}}老师管理的项目类别
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon small @click="fullscreen = !fullscreen" class="elevation-1">
          <v-icon size="20">mdi-fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- 分隔线 -->
      <v-divider color="primary lighten-1" />

      <v-card-text
          class="pa-4"
          style="
          background-color: #f8fafc;
          flex: 1;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch; /* 移动端流畅滚动 */
          min-height: 0;
        "
      >

        <v-layout wrap class="mb-3">
          <v-flex xs12 sm12>
            <proj-tpe-tree
                :key="treeKey"
                :values="form.types"
                @input="onTreeInput"
                ref="projTree"
                @click = "projTypeChange"
            />
          </v-flex>
        </v-layout>

        <!-- 已选择的项目类别显示 -->
        <v-layout wrap class="mt-4">
          <v-flex xs12>
            <h3 class="title">已选择的项目类别：</h3>
            <div v-if="form.types.length === 0" class="grey--text caption mt-2">
              暂无选中类别
            </div>

            <!-- 使用 v-layout + v-flex 布局 chips -->
            <v-layout row wrap style="gap: 6px; padding: 8px 0">
              <v-chip
                  v-for="(id, index) in form.types"
                  :key="index"
                  close
                  @input="removeType(index)"
                  class="ma-0"
                  small
              >
                {{ typeMap[id] || `未知类别(${id})` }}
              </v-chip>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>

      <!-- 操作按钮 -->
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
            color="primary"
            depressed
            class="px-6"
            @click="projManager = false"
        >
          <v-icon left>close</v-icon>
          关闭
        </v-btn>

        <v-btn
            color="primary"
            depressed
            class="px-6"
            @click = "onSave"
        >
          <v-icon left>save</v-icon>
          确定
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ProjTpeTree from '@/components/proj/widgets/ProjTpeTree'
import axios from "axios";

export default {
  name: "ProjManager",
  props: ['userId', 'userName', 'value'],
  components: { ProjTpeTree},
  data() {
    return {
      fullscreen: false,
      form: {
        types: []
      },

      treeKey: 1,

      typeMap: {}, // 新增：dbid -> name 映射表，如 {1: '前端开发', 2: '后端'}
      manageType : []
    };
  },


  computed: {
    projManager: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
  },

  mounted() {
    // 如果没有用 @load，可以用 $nextTick + 延迟尝试
    this.$nextTick(() => {
      setTimeout(() => {
        this.buildTypeMap();
      }, 500); // 等待 axios 加载
    });

  },

  watch: {
    // 当树数据加载完成时（items 变化），重建映射
    '$refs.projTree': {
      handler() {
        this.buildTypeMap();
      },
      deep: true,
      immediate: true
    },

    userId() {
      window.console.log("选择用户")
      window.console.log(this.userId)
      const vm = this
      this.axios.get(`/api/syst/user/manager/projType${vm.userId}`, {params: {limit: 512, disabled: 'F', sort: 'rank.asc'}})
      .then(
              rspProjTye => {
                vm.manageType = rspProjTye.data;
                window.console.log(vm.manageType)
                const typeIds = vm.manageType.map(item => item.projTypeId);
                vm.form.types = typeIds;

                this.waitForTreeAndSync(typeIds);

                window.console.log(vm.manageType)
              }
      )
    }
  },

  methods: {

    onTreeInput(selectedIds) {
      this.form.types = selectedIds; // 树 → chip
    },

    projTypeChange() {
      window.console.log('form.types 数据类型:', typeof this.form.types[0], '值:', this.form.types);
    },

    // 手动移除某个已选类别
    removeType(index) {
      this.form.types.splice(index, 1);
      this.$nextTick(() => {
        const tree = this.$refs.projTree;
        if (tree && tree.items) {
          tree.selected = this.findNodesById(tree.items, this.form.types);
        }
      });
    },

    waitForTreeAndSync(expectedTypeIds) {
      const maxAttempts = 50;
      let attempts = 0;

      const check = () => {
        const projTree = this.$refs.projTree;

        // 检查 projTree 是否存在
        if (!projTree) {
          attempts++;
          if (attempts < maxAttempts) {
            setTimeout(check, 50);
          } else {

          }
          return;
        }

        // 检查 items 是否已加载
        if (!projTree.items || projTree.items.length === 0) {
          attempts++;
          if (attempts < maxAttempts) {

            setTimeout(check, 50);
          } else {

          }
          return;
        }

        // ✅ 条件满足：items 已加载，开始同步 selected

        this.syncTreeSelection(projTree, expectedTypeIds);
      };

      check(); // 立即开始检查
    },

    syncTreeSelection(projTree, typeIds) {
      if (!Array.isArray(typeIds) || typeIds.length === 0) {
        projTree.selected = [];
        return;
      }

      const selectedNodes = this.findNodesById(projTree.items, typeIds);

      // 🔥 关键：必须确保 selected 是新数组，触发 watch
      projTree.selected = [...selectedNodes];

    },


    findNodesById(nodes, ids) {
      const result = [];
      const traverse = (list) => {
        if (!list) return;
        list.forEach(node => {
          if (ids.includes(node.dbid)) {
            result.push(node);
          }
          traverse(node.children);
        });
      };
      traverse(nodes);
      return result;
    },

    buildTypeMap() {
      const projTree = this.$refs.projTree;
      const tree = projTree && projTree.items ? projTree.items : null;

      if (!tree) {
        return;
      }

      const map = {};
      const traverse = (nodes) => {
        if (!Array.isArray(nodes)) return;
        nodes.forEach(node => {

          if (node.dbid != null && node.name) {
            map[node.dbid] = node.name;
          } else {
          }

          if (Array.isArray(node.children)) {
            traverse(node.children); // 确保递归子节点
          }
        });
      };

      traverse(tree);
      this.typeMap = map;

    },

    onSave() {
      window.console.log("开始绑定！")
      const vm = this

      if (!vm.form.types || !Array.isArray(vm.form.types) || vm.form.types.length === 0) {
        alert('请至少选择一个项目类别')
        return // ❌ 阻止后续执行
      }

      axios.post(`/api/syst/user/projManager/${vm.userId}`,
          {
            types : vm.form.types
            })
          .then(res => {
            // 现在 400 也会进入 .then()！
            if (res.status === 200) {
              vm.projManager = false
            }
          })
    }
  }
}
</script>

<style scoped>

</style>